import { Component, ElementRef, ViewChild,
        Input, Output, EventEmitter } from '@angular/core';
declare var Chart: any;

@Component({
  selector: 'polar-chart',
  templateUrl: './polar-chart.html',
  styleUrls: ['./polar-chart.scss'],
})

export class PolarChart {

  /**
   * 캔버스 element
   */
  @ViewChild('cvs') el: ElementRef;

  /**
   * 차트 object
   */
  private myChart: any;

  /**
   * 폴라 차트에 표시될 검사 데이터
   */
  private polarData: any[] = [];

  /**
   * 초검 데이터
   */
  private firstData: any[] = [];

  /**
   * 재검 데이터
   */
  private lastData: any[] = [];

  /**
   * 비교버튼을 보여줄 값
   */
  btnShow: boolean = false;

  /**
   * 비교 버튼 상태값 가져옴
   */
  @Output('onClickEvent') private $onClickEvent: EventEmitter<any> = new EventEmitter();

  /**
   * @constructor
   */
  constructor() {}

  /**
   * 초검 & 재검 데이터 가져옴
   */
  @Input('testData') set setTestData(data: any[]) {
    if (!data) return;

    this.firstData = data[0];
    this.lastData = data[1];

    // 재검 데이터가 없을 경우
    if (this.lastData == null) {
      this.btnShow = false;
      this.polarData = this.firstData;
    } else {
      this.btnShow = true;
      this.polarData = this.lastData;
    }

    // 차트 그리기 함수 실행
    this.draw();
  }

  /**
   * 차트 그리기
   */
  private draw() {
    // 운동5개 색
    const colors = ['#7dce5b', '#ef4582', '#9a9cff', '#fa573c', '#5a91f2'];
    // level color
    const lvColor = ['#e60012', '#fbb03b', '#33aeb6'];
    // line grey color
    const defaultLineColor = 'rgba(158,158,158,0.2)';
    const metaIdx = 0;

    const canvas = this.el.nativeElement as any;
    const ctx = canvas.getContext('2d');

    const $data = {
      labels: ['근육', '보행', '공간', '소뇌', '계획'],
      datasets: [{
        data: this.polarData,
        backgroundColor: [
          'rgba(155,206,91,0.2)',
          'rgba(239,69,130,0.2)',
          'rgba(154,156,255,0.2)',
          'rgba(250,87,60,0.2)',
          'rgba(90,145,242,0.2)',
        ],
        borderWidth: 0,
      }],
    };

    const $options = {
      responsive: true,
      responsiveAnimationDuration:  1,
      maintainAspectRatio: false,
      legend:{
        display: false,
      },
      tooltips:{
        enabled: false,
      },
      hover: {
        display: false,
      },
      scale:{
        lineArc: true, // so that lines are circular
        beforeFit: (scale) => {
          if (scale.chart.config.data.labels.length === 5) {
            const pointLabelFontSize = Chart.helpers.
              getValueOrDefault(
                scale.options.pointLabels.fontSize,
                Chart.defaults.global.defaultFontSize);
            scale.height *= (2 / 2.2);
            scale.height -= pointLabelFontSize;
          }
        },
        gridLines: {
          display: true,
          color: [
            defaultLineColor,
            defaultLineColor,
            defaultLineColor,
            lvColor[0],
            defaultLineColor,
            defaultLineColor,
            lvColor[1],
            defaultLineColor,
            defaultLineColor,
            lvColor[2],
          ],
          lineWidth: 1,
          drawOnChartArea: false,
          drawTicks: false,
          tickMarkLength: 30,
        },
        ticks: {
          display: false,
          beginAtZero: true,
          max: 100, // 범위 지정
          min: 0, // 범위지정
          stepSize: 10, // 33%마다 간격 표시
          showLabelBackdrop: false,
          mirror: true,
          labelOffset: 30,
        },
        reverse: false,
        scaleLabel:{ // 좌표 설명 타이틀
          display: true,
          fontColor: 'pink',
          labelString: 'aaaa',
        },
      },
      animation: {
        duration: 500,
        onProgress() {
          const dataset = this.data.datasets[0];
          let metaIdx = 0;

          // 중앙 좌표값 가져옴
          for (metaIdx = 0; metaIdx < 100; metaIdx += 1) {
            if (dataset._meta[metaIdx]) {
              break;
            }
          }
          this.ox = dataset._meta[metaIdx].data[0]._model.x;
          this.oy = dataset._meta[metaIdx].data[0]._model.y;

          // 좌표 이동
          ctx.translate(this.ox, this.oy);

          // 표시할 좌표값
          let x = 0;
          let y = 0;
          let degree = 306;
          let line = 270;
          ctx.textAlign = 'center';
          ctx.font = 'bold 20px';
          let j = 0;
          let i = 0;

          // 레벨 표시
          for (j = 0; j < 3; j += 1) {
            const rad = this.scale.drawingArea; // 길이
            const splitRad = rad / 10;
            ctx.textBaseline = 'top';
            ctx.fillStyle = lvColor[j];
            ctx.fillText('lv.' + (j + 1), x, y - (splitRad * ((j + 1) * 3 + 1)));
          }

          for (i = 0; i < 5; i += 1) {
            // 데이터 표시
            let radius = this.radiusLength; // 길이
            const r = Math.PI * degree / 180;

            // 3번째 텍스트는 위쪽으로 조금 이동
            radius = i === 2 ? radius - 5 : radius;

            // 1번째와 5텍스트는 x축이동이 필요
            const plusx =  i === 0 ? 20 : i === 4 ? -20 : 0;

            // 좌표 값 설정
            x = Math.cos(r) * radius;
            y = Math.sin(r) * radius;

            ctx.textBaseline = 'middle';
            ctx.fillStyle = colors[i];
            ctx.fillText($data.labels[i], x + plusx, y);
            ctx.fillStyle = '#000';
            const percent = dataset.data[i];
            ctx.fillText(percent + '%', x + plusx, y + 15);

            degree += 72;
            if (degree > 360) {
              degree = degree - 360;
            }

            // 앵글 라인 그림
            const dataRad = this.scale.drawingArea; // 길이
            const r2 = (Math.PI * line / 180);

            // 1번째 좌표 값 설정
            x = Math.cos(r2) * dataRad;
            y = Math.sin(r2) * dataRad;

            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(x, y);
            ctx.strokeStyle = 'rgba(158,158,158,0.2)';
            ctx.stroke();

            line += 72;
            if (line > 360) {
              line = line - 360;
            }
          }
          // 좌표값 초기상태로 다시 이동
          ctx.translate(-this.ox, -this.oy);
        },
      },
    };

    this.myChart = new Chart(ctx, {
      type: 'polarArea',
      data: $data,
      options: $options,
    });
  }

  /**
   * 비교버튼 터치 시작 이벤트
   */
  touchStart() {
    this.polarData = this.firstData;
    this.myChart.data.datasets[0].data = this.polarData;
    this.myChart.update();
    this.$onClickEvent.emit(true);
  }

  /**
   * 비교버튼 터치 종료 이벤트
   */
  touchEnd() {
    this.polarData = this.lastData;
    this.myChart.data.datasets[0].data = this.polarData;
    this.myChart.update();
    this.$onClickEvent.emit(false);
  }
}
